customElements.define('sticky-product-form', class StickyProductForm extends HTMLElement {
    constructor() {
      super();

      this.stickyNavMenu();
    }

    addClass(entry) { 
      this.querySelectorAll('.sticky-nav-menu li').forEach(list_element => {
        const dataScrollWithoutDot = list_element.dataset.scroll.replace('.', '');
        if(entry.classList.contains(dataScrollWithoutDot)) {
          list_element.classList.add('active');
        }
      });
    }

    removeClass(entry) { 
      this.querySelectorAll('.sticky-nav-menu li').forEach(list_element => {
        const dataScrollWithoutDot = list_element.dataset.scroll.replace('.', '');
        if(entry.classList.contains(dataScrollWithoutDot)) {
          list_element.classList.remove('active');
        }
      });
    }

    intersectionSetup(elements) { 
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const intersecting = entry.intersecting;
          if(entry.isIntersecting) {
            this.addClass(entry.target);
          } else {
            this.removeClass(entry.target);
          }
        });
      });
      elements.forEach(el => {
        console.log("ELEMENT: ", el);
        if(el !== null && el !== undefined) {
          observer.observe(el)
        }
      });
    }

    stickyNavMenu () {
      const sectionsArray = [];
      this.querySelectorAll('.sticky-nav-menu li').forEach(list_element => {
        const elementToScrollTo = list_element.dataset.scroll;
        if(elementToScrollTo !== '') {
          list_element.addEventListener('click', () => {
            document.querySelector(elementToScrollTo).scrollIntoView({
              behavior: 'smooth'
            })
          });
          if(document.querySelector(elementToScrollTo) !== null) {
            sectionsArray.push(document.querySelector(elementToScrollTo))
          }
        }
      });
      this.intersectionSetup(sectionsArray);
    }

    connectedCallback() {
      console.log('connectedCallback')
      this.elOffsetTop = this.offsetTop

      window.addEventListener('scroll', this.scrollListener.bind(this),);
    }

    scrollListener() {
      if(window.scrollY >= this.elOffsetTop) {
        this.classList.add('product--sticky-form--fixed');
        document.body.style.paddingTop = `${this.offsetHeight}px`;
      } else {
        console.log('else');
        this.classList.remove('product--sticky-form--fixed');
        document.body.style.paddingTop = `0px`;
      }
    }
  });